<template>
  <v-tab-item :id="'3'" style="width: 100%; height: 500px">
    <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>
    <v-card>
      <v-flex xs12 sm12 md12 pa-2>
        <v-form ref="formRateProperty" v-model="validRate" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12 sm6 md3>
              <v-select
                label="Oda"
                :items="rooms"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="
                  rateProperty.HotelProducts.HotelProduct[0].RoomTypes
                    .RoomType[0].RoomTypeCode
                "
                item-text="type"
                item-value="roomId"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-select
                label="Konsept"
                :items="rates"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="
                  rateProperty.HotelProducts.HotelProduct[0].RatePlans
                    .RatePlan[0].RatePlanCode
                "
                item-text="ratePlanType"
                item-value="rateId"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-select
                :items="mealPlans"
                item-text="FilterName"
                item-value="FilterId"
                v-model="
                  rateProperty.HotelProducts.HotelProduct[0].ValueAddInclusions
                    .MealPlan[0].MealPlanCode
                "
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                label="Öğün Tipi"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md2>
              <v-btn block color="primary" @click="saveRateProperty()" dark
                >Ekle</v-btn
              >
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>

      <v-flex xs12 sm12 md12 pa-2>
        <v-flex xs12 sm12 md12 pa-2>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            class="elevation-1"
            item-key="id"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.roomName }}</td>
              <td class="text-xs-left">{{ props.item.rateName }}</td>
              <td class="text-xs-left">
                {{ getMealPlanName(props.item.mealPlans[0].yemekId) }}
              </td>
              <td class="text-xs-left">
                <v-btn
                  flat
                  icon
                  small
                  @click="editProperty(props.item)"
                  color="primary"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  icon
                  small
                  @click="deleteRateProperty(props.item.id)"
                  color="primary"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-flex>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="editPropertyDialog" persistent max-width="900px">
        <v-card>
          <v-card-title>
            <span class="headline">Konsept Özellik Güncelle</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-flex xs12 sm12 md12 pa-2>
                <v-form
                  ref="formRatePropertyDialog"
                  v-model="validRate"
                  lazy-validation
                >
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        label="Oda"
                        :items="rooms"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        v-model="updateProperty.RoomTypeCode"
                        item-text="type"
                        item-value="roomId"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        label="Konsept"
                        :items="rates"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        v-model="updateProperty.RatePlanCode"
                        item-text="ratePlanType"
                        item-value="rateId"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        :items="mealPlans"
                        item-text="FilterName"
                        item-value="FilterId"
                        v-model="updateProperty.MealPlanCode"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        label="Öğün Tipi"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click.native="editPropertyDialog = false"
              >Kapat</v-btn
            >
            <v-btn color="blue darken-1" flat @click="updateRateProperty()"
              >Güncelle</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-tab-item>
</template>


<script>
import auth from "@/api/auth.js";
import loadingcomp from "@/components/app/customcomp/loadingcomp"

export default {
  props: {
    isChoosen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingvmodel:false,
      editPropertyDialog: false,
      validRate: true,
      valid: true,
      rates: [],
      rooms: [],
      items: [],
      mealPlans: [
        {
          FilterId: 0,
          FilterName: "(None)",
        },
        {
          FilterId: 1,
          FilterName: "All inclusive",
        },
        {
          FilterId: 3,
          FilterName: "Bed & breakfast",
        },
        {
          FilterId: 10,
          FilterName: "Full board",
        },
        {
          FilterId: 12,
          FilterName: "Half board",
        },
        {
          FilterId: 24,
          FilterName: "Ultra All Inclusive",
        },
        {
          FilterId: 25,
          FilterName: "No plan",
        },
        {
          FilterId: 125,
          FilterName: "Only Room",
        },
      ],
      headers: [
        {
          text: "Oda Adı",
        },
        {
          text: "Konsept Adı",
        },
        {
          text: "Yemek Planı",
        },
        {
          text: "İşlem",
        },
      ],
      updateProperty: {
        HotelCode: 0,
        RoomTypeCode: null,
        RatePlanCode: null,
        RatePlanName: null,
        MealPlanCode: 0,
        MealCodeId: 0,
      },
      rateProperty: {
        NextRequest: true,
        HotelProducts: {
          HotelCode: 0,
          HotelProduct: [
            {
              RoomTypes: {
                RoomType: [
                  {
                    RoomTypeCode: null,
                  },
                ],
              },
              RatePlans: {
                RatePlan: [
                  {
                    RatePlanCode: null,
                    RatePlanName: null,
                  },
                ],
              },
              ValueAddInclusions: {
                MealPlan: [
                  {
                    MealPlanCode: 0,
                  },
                ],
              },
            },
          ],
        },
      },
    };
  },
  watch: {
    isChoosen: function () {
      if (this.isChoosen) {
        this.getRatePropertyList();
        this.getRateList();
        this.getRoomList();
      }
    },
  },
  methods: {
    updateRateProperty() {
      if (this.$refs.formRatePropertyDialog.validate()) {
        let selectedRate = this.rates.find(
          (x) => x.rateId == this.updateProperty.RatePlanCode
        );
        var selectedRoom = this.rooms.find(
          (x) => x.roomId == this.updateProperty.RoomTypeCode
        );

        this.updateProperty.RatePlanCode =
          this.updateProperty.RatePlanCode.toString();
        this.updateProperty.RoomTypeCode =
          this.updateProperty.RoomTypeCode.toString();
        this.updateProperty.RoomTypeName = selectedRoom.type;
        this.updateProperty.RatePlanName = selectedRate.ratePlanType;
        var params = this.updateProperty;

        this.$http
          .post(
            auth.HOTELRUNNER_API_URL + "api/v1/UpdateRateProperty",
            params,
            {
              headers: {
                Authorization:
                  "Basic " +
                  window.btoa(
                    auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                  ),
              },
            }
          )
          .then(
            (response) => {
              this.text1 = response.body.Message;
              this.snackbar = true;
              this.editPropertyDialog = false;
              this.getRatePropertyList();
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-OTA_HotelRatePlanNotif";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable-OTA_HotelRatePlanNotif";
                this.snackbar = true;
              }
            }
          );
      }
    },
    editProperty(property) {
      var rateDetails = this.rates.find(
        (x) => x.ratePlanType == property.rateName.trim()
      );
      this.updateProperty.RatePropertyId = property.id;
      this.updateProperty.HotelCode = this.$route.query.kod;
      this.updateProperty.RoomTypeCode = property.roomId;
      this.updateProperty.RoomTypeName = property.roomName;
      this.updateProperty.RatePlanCode = rateDetails.rateId;
      this.updateProperty.RatePlanName = rateDetails.ratePlanType;
      this.updateProperty.MealPlanCode = property.mealPlans[0].yemekId;
      this.updateProperty.MealCodeId = property.mealPlans[0].ref;
      this.editPropertyDialog = true;
    },
    deleteRateProperty(id) {
      this.loadingvmodel = true;
      var params = {
        RatePropertyId: id,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/DeleteRateProperty", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            if (response.body.status) {
              this.getRatePropertyList();
              this.loadingvmodel = false;
            } else {
              this.text1 = response.body.message;
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-DeleteRateProperty";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-DeleteRateProperty";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getMealPlanName(val) {
      let mealPlan = this.mealPlans.find((x) => x.FilterId == val);
      return mealPlan.FilterName;
    },
    getRatePropertyList() {
      this.loadingvmodel = true;

      var params = {
        OtelId: this.$route.query.kod,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/RatePropertyList", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.items = [];
            this.items = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 =
                "Service Unavailable-RatePropertyList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 =
                "Service Unavailable-RatePropertyList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getRoomList() {
      var params = {
        OtelId: this.$route.query.kod,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/RoomList", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.rooms = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 =
                "Service Unavailable-OTA_HotelDescriptiveContentNotif";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 =
                "Service Unavailable-OTA_HotelDescriptiveContentNotif";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    },
    getRateList() {
      var params = {
        OtelId: this.$route.query.kod,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/RateList", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.rates = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RateList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RateList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    saveRateProperty() {
      if (this.$refs.formRateProperty.validate()) {
        this.loadingvmodel = true;
        this.rateProperty.HotelProducts.HotelCode = this.$route.query.kod;
        let selectedRate = this.rates.find(
          (x) =>
            x.rateId ==
            this.rateProperty.HotelProducts.HotelProduct[0].RatePlans
              .RatePlan[0].RatePlanCode
        );
        this.rateProperty.HotelProducts.HotelProduct[0].RatePlans.RatePlan[0].RatePlanName =
          selectedRate.ratePlanType;
        this.rateProperty.HotelProducts.HotelProduct[0].ValueAddInclusions.MealPlan[0].MealPlanCode =
          this.rateProperty.HotelProducts.HotelProduct[0].ValueAddInclusions.MealPlan[0].MealPlanCode.toString();
        this.rateProperty.HotelProducts.HotelProduct[0].RoomTypes.RoomType[0].RoomTypeCode =
          this.rateProperty.HotelProducts.HotelProduct[0].RoomTypes.RoomType[0].RoomTypeCode.toString();

        this.rateProperty.HotelProducts.HotelProduct[0].RatePlans.RatePlan[0].RatePlanCode =
          this.rateProperty.HotelProducts.HotelProduct[0].RatePlans.RatePlan[0].RatePlanCode.toString();
        var params = this.rateProperty;

        this.$http
          .post(
            auth.HOTELRUNNER_API_URL + "api/hotels/ota/OTA_HotelProductNotif",
            params,
            {
              headers: {
                Authorization:
                  "Basic " +
                  window.btoa(
                    auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                  ),
              },
            }
          )
          .then(
            (response) => {
              this.text1 = response.body.Message;
              this.snackbar = true;
              this.getRatePropertyList();
              this.loadingvmodel = false;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-OTA_HotelRatePlanNotif";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-OTA_HotelRatePlanNotif";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
      }
    },
  },
  components:{
    loadingcomp
  }
};
</script>
